import { RouterProvider } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';

import Notifications from 'containers/Notifications';

import ErrorBoundary from 'components/ErrorBoundary';

import ThemeProvider from './theme/provider';
import { setHtmlLang } from './services/OneTrust/setHtmlLang';
import { initOneTrust } from './services/OneTrust';
import router from './router';

initOneTrust(import.meta.env.ONE_TRUST_ID);
setHtmlLang();

function App() {
    return (
        <StyleSheetManager>
            <ThemeProvider>
                <Notifications />
                <ErrorBoundary>
                    <RouterProvider router={router} />
                </ErrorBoundary>
            </ThemeProvider>
        </StyleSheetManager>
    );
}

export default App;
